import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { Hotel_HotelInfoSettingsPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useHotelInfoQuery = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(Hotel_HotelInfoSettingsPage_Query, {
		variables: {
			hotelID,
		},
	});

	return {
		data,
	};
};
